import { Box, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef, useContext } from "react";
import DialogAnimate from "src/components/animate/DialogAnimate";
import { varFade } from "src/components/animate/variants";
import Context from "src/pages/App/AppSettings/Customization/context";

import BackBtn from "./components/BackBtn";
import CustomizeCard from "./CustomizeCard";

type Props = {};

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement;
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction='right' ref={ref} {...props} />;
});

export default function CustomizeAppDialog({}: Props) {
	const { state, actions } = useContext(Context);
	const variants = varFade({
		distance: 120,
		durationIn: 0.32,
		durationOut: 0.24,
		easeIn: "easeInOut"
	}).inLeft;

	return (
		<DialogAnimate
			maxWidth={false}
			fullScreen
			onClose={actions.hideCustomDialog}
			open={state.showDialog}
			keepMounted
			variants={variants}
			TransitionComponent={Transition}
			sx={{ backgroundColor: "background.default" }}
		>
			<Box
				sx={{
					backgroundColor: "background.default",
					p: 3,
					height: "100%",
					alignContent: "center"
				}}
			>
				<BackBtn onClick={actions.hideCustomDialog} />
				<CustomizeCard />
			</Box>
		</DialogAnimate>
	);
}
